/**
 * Created by Ning Jiang on 5/7/2018.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";

export class WildNudgeReelAttentionView extends BaseView {

    private _layer:ScalableLayer;
    private _fire:TimelineSprite;

    constructor() {
        super();

        this._layer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.REEL_ATTENTION.name);
    }

    protected initAnimations():void {
        this._fire = new TimelineSprite(GameResources.getTextures("wild_fire"));
        this._fire.anchor.set(0.5, (3.5 * GameConfig.instance.SYMBOL_HEIGHT + 359 + 12) / 928);
        this._fire.scale.set(2, 1.95);
        this._fire.blendMode = PIXI.BLEND_MODES.ADD;
    }

    public playAttention(reelId:number):void {
        const position:[number, number] = Helper.getSymbolPositions(reelId, 3);
        this._fire.position.set(position[0], position[1]);
        this._layer.addChild(this._fire);
        this._fire.playLoop();
    }

    public stopAttention():void {
        this._fire.stopLoop();

        if(this._layer.children.indexOf(this._fire) > -1) {
            this._layer.removeChild(this._fire);
        }
    }
}